import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Paper, BottomNavigation, BottomNavigationAction, Menu, MenuItem, Typography, Badge,
} from '@mui/material';

/*
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import MapIcon from '@mui/icons-material/Map';
import PersonIcon from '@mui/icons-material/Person';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
*/

import DescriptionIcon from '@mui/icons-material/Description';
import MapIcon from '@mui/icons-material/Map';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from '@mui/styles';

import { sessionActions } from '../../store';
import { useTranslation } from './LocalizationProvider';
import { useRestriction } from '../util/permissions';
import { nativePostMessage } from './NativeInterface';

const BottomMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const t = useTranslation();

  const readonly = useRestriction('readonly');
  const disableReports = useRestriction('disableReports');
  const user = useSelector((state) => state.session.user);
  const socket = useSelector((state) => state.session.socket);

  const [anchorEl, setAnchorEl] = useState(null);

  const currentSelection = () => {
    if (location.pathname === `/settings/user/${user.id}`) {
      return 'account';
    } if (location.pathname.startsWith('/settings')) {
      return 'settings';
    } if (location.pathname.startsWith('/reports')) {
      return 'reports';
    } if (location.pathname === '/') {
      return 'map';
    }
    return null;
  };

  const handleAccount = () => {
    setAnchorEl(null);
    navigate(`/settings/user/${user.id}`);
  };

  const handleLogout = async () => {
    setAnchorEl(null);

    const notificationToken = window.localStorage.getItem('notificationToken');
    if (notificationToken) {
      window.localStorage.removeItem('notificationToken');
      const tokens = user.attributes.notificationTokens?.split(',') || [];
      if (tokens.includes(notificationToken)) {
        const updatedUser = {
          ...user,
          attributes: {
            ...user.attributes,
            notificationTokens: tokens.length > 1 ? tokens.filter((it) => it !== notificationToken).join(',') : undefined,
          },
        };
        await fetch(`/api/users/${user.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedUser),
        });
      }
    }

    await fetch('/api/session', { method: 'DELETE' });
    nativePostMessage('logout');
    navigate('/login');
    dispatch(sessionActions.updateUser(null));
  };

  const handleSelection = (event, value) => {
    switch (value) {
      case 'map':
        navigate('/');
        break;
      case 'reports':
        navigate('/reports/route');
        break;
      case 'settings':
        navigate('/settings/preferences');
        break;
      /*
      case 'account':
        setAnchorEl(event.currentTarget);
        break;
      */
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  };
  // editado
  const useStyles = makeStyles(() => ({
    selected: {
      '&.Mui-selected': {
        bgcolor: '#91e2ff',
        color: '#91e2ff',
      },
    },
  }));

  const classes = useStyles();

  return (
    <Paper square elevation={3}>
      <BottomNavigation value={currentSelection()} sx={{ bgcolor: '#6B809B' }} onChange={handleSelection} showLabels>
        <BottomNavigationAction label={t('menuTitle')} className={classes.selected} sx={{ color: '#fff' }} icon={<MenuIcon />} value="settings" />
        <BottomNavigationAction label={t('mapTitle')} className={classes.selected} sx={{ color: '#fff' }} icon={(<Badge color="error" variant="dot" className={classes.selected} overlap="circular" invisible={socket !== false}><MapIcon /></Badge>)} value="map" />
        {!disableReports && (
          <BottomNavigationAction label={t('reportTitle')} className={classes.selected} sx={{ color: '#fff' }} icon={<DescriptionIcon />} value="reports" />
        )}
        {readonly ? (
          <BottomNavigationAction label={t('loginLogout')} sx={{ color: '#fff' }} icon={<ExitToAppIcon />} value="logout" />
        ) : (
          <BottomNavigationAction label={t('suporteWhats')} sx={{ color: '#fff' }} component="a" target="_blank" icon={<WhatsAppIcon />} href="https://api.whatsapp.com/send?phone=31624696273&text=Support%20Platform" />
        )}
        <BottomNavigationAction label={t('loginLogout')} sx={{ color: '#fff' }} icon={<ExitToAppIcon />} value="logout" />
      </BottomNavigation>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem sx={{ color: '#fff' }} onClick={handleAccount}>
          <Typography color="textPrimary">{t('settingsUser')}</Typography>
        </MenuItem>
        <MenuItem sx={{ color: '#fff' }} onClick={handleLogout}>
          <Typography color="error">{t('loginLogout')}</Typography>
        </MenuItem>
      </Menu>
    </Paper>
  );
};

export default BottomMenu;
